import { InputOtp } from '@heroui/react';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BlurContainer, CodeContainer, CodeTitle } from './CodeModal.styled';

interface CodeModalProps {
    conferenceCode?: number;
}
export const CodeModal: FC<CodeModalProps> = ({ conferenceCode }) => {
  const { t } = useTranslation();
  const [userCode, setUserCode] = useState('');
  const [verificationError, setVerificationError] = useState<boolean>(false);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (userCode.length > 0) {
      setVerificationError(false);
    }

    if (userCode.length === 4) {
      const isCodeCorrect = parseInt(userCode, 10) === conferenceCode;

      if (isCodeCorrect) {
        setVerificationError(false);
        setShowContent(true);
      } else {
        setVerificationError(true);
        setUserCode('');
      }
    }
  }, [userCode, conferenceCode]);

  if (!conferenceCode || showContent) return null;
  return (
    <BlurContainer>
      <CodeContainer>
        <CodeTitle>{t('conferences_screen.enter_code')}</CodeTitle>
        <InputOtp size="lg" length={4} value={userCode} onValueChange={setUserCode} />
        {verificationError && <p style={{ color: 'red' }}>{t('conferences_screen.wrong_code')}</p>}
      </CodeContainer>
    </BlurContainer>
  );
};
